import {ReducedProductData} from "@/lib/storefront/product/product";
import {formatPrice} from "@/lib/helper";

export function generateBasePriceInfoClient(
  isoLocale: string,
  article: ReducedProductData | undefined,
  salePrice: number | undefined
) {
  console.log("generateBasePriceInfoClient")
  if (
    article &&
    salePrice &&
    article.basicPriceQuantity &&
    article.basicPriceUnit &&
    article.basicPriceUnit !== "" &&
    article.totalQuantity &&
    article.currency &&
    article.currency !== "" &&
    article.currency !== "N/A"
  ) {
    //console.log(article.currency)
    const pricePerUnit = salePrice / article.totalQuantity
    if(pricePerUnit>0) {
      return `${formatPrice(isoLocale, pricePerUnit, article.currency)} / ${article.basicPriceQuantity} ${article.basicPriceUnit}`
    }
  }

  return "-"
}